import { formatDisplayDate } from './dateHelpers';

/**
 * Formats date for display in Polish locale (DD.MM.YYYY)
 * @deprecated Use formatDisplayDate() from dateHelpers.ts for better consistency
 */
export const formatDate = (date: string | Date): string => {
  if (typeof date === 'string') {
    return formatDisplayDate(date);
  }
  return new Date(date).toLocaleDateString('pl-PL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
